/* eslint-disable arrow-body-style */
import { jwtDecode } from "jwt-decode";

import { LOGS_ENABLED } from '../config/config';
import StateHelper from '../helpers/stateHelper';

// payment method svgs
import VisaCard from '../assets/images/visa-card.svg'
import AmexCard from '../assets/images/amex-card.svg'
import DiscoverCard from '../assets/images/discover-card.svg'
import MasterCard from '../assets/images/master-card.svg'
import JcbCard from '../assets/images/jcb-card.svg'
import { has, size } from "lodash";

/* -------------------------------------------------------------------------- */
/*                                   String                                   */
/* -------------------------------------------------------------------------- */
/**
 * This function will return a given string after removing trailing slash
 * @param {String} value string for modify
 * @returns modified string
 */
const removeTrailingSlash = (value = '') => value.replace(/\/$/, '');

const replaceStrParameters = (value, parameters) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const param of Object.keys(parameters)) {
    value = value.replace('{{'.concat(param).concat('}}'), parameters[param]);
  }

  return value;
};

/* -------------------------------------------------------------------------- */
/*                                    Array                                   */
/* -------------------------------------------------------------------------- */
/**
 * This function will return true, when the given index is the last
 * @param {number} index current element array index
 * @param {number} length array length
 * @returns {boolean}
 */
const isLastElementInArray = (index = 0, length = 0) => length - 1 === index;

/**
 * This function will return new array after removing given element.
 * This will consider content of the given item to match correct element.
 * @param {Array} arr Array to remove element
 * @param {any} itemToRemove The item which needs to remove from the array
 * @returns {Array}
 */
const removeElementFromArrayConsideringData = (arr, itemToRemove) =>
  arr.filter(i => i !== itemToRemove);

/**
 * This function will return new array after adding given element.
 * @param {Array} arr Array to push new element
 * @param {*} itemToPush The item which needs to push to the array
 * @returns {Array}
 */
const pushToArray = (arr, itemToPush) => [...arr, itemToPush];

/* -------------------------------------------------------------------------- */
/*                                    Logs                                    */
/* -------------------------------------------------------------------------- */
/**
 * This function will return true, if REACT_APP_LOGS_ENABLED is true
 * @returns {Boolean}
 */
const isLogsEnabled = () => LOGS_ENABLED === 'true' || LOGS_ENABLED === true;

const filterStateName = stateAbbName => {
  const state = StateHelper.STATES.filter(item => {
    return item.label === stateAbbName;
  });
  return state[0].value || null;
};

/**
 * 
 * @param {*} yearsForward 
 * @returns array of years
 */
const generateYearOptions = (yearsForward) => {
  const currentYear = new Date().getFullYear()
  const years = []

  for (let i = currentYear; i <= currentYear + yearsForward; i++) {
    years.push({ value: i, label: i.toString() })
  }

  return years
}

const returnCardImage = (brand) => {
  switch (brand) {
    case 'discover':
      return DiscoverCard
    case 'visa':
      return VisaCard
    case 'amex':
      return AmexCard
    case 'mastercard':
      return MasterCard
    case 'jcb':
      return JcbCard
    default:
      break
  }
}

const decodeToken = (token) => {
  return jwtDecode(token);
}

const exportHtmlToDoc = (input, documentName) => {
  let html = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
  var body1 = `${input}`;
  var footer = "</body></html>";
  html = html + body1 + footer;

  // link URL
  var url = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

  // Creates the download link element dynamically
  var downloadLink = document.createElement("a");
  document.body.appendChild(downloadLink);

  // Link to the file
  downloadLink.href = url;

  // Setting up file name
  downloadLink.download = `${documentName}.doc`;

  // Triggering the function
  downloadLink.click();

  // Remove the <a> tag after download starts.
  document.body.removeChild(downloadLink);
}


const formatISOToDate = (isoDateStr, withTime = false) => {
  const date = new Date(isoDateStr);

  const pad = (n) => n.toString().padStart(2, '0');

  const formattedDate = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;

  return withTime ? formattedDate : formattedDate.split(' ')[0];
}

const formatUnixToDate = (unixTimestampStr, withTime = false) => {
  const timestamp = Number(unixTimestampStr) * 1000;
  const date = new Date(timestamp);

  const dateStr = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).replace(/ /g, ' ');

  if (!withTime) return dateStr;

  const timeStr = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return `${dateStr} ${timeStr}`;
};

const capitalizeFirstLetter = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

const normalizePriceFormat = (priceStr) => {
  const numeric = parseFloat(priceStr);
  if (isNaN(numeric)) return '0.00';
  return `${numeric.toFixed(2)}`;
}

const processCounts = (data) => {
  const sortedFolderCounts = {};

  data.map(countObj => {
    if (Object.keys(sortedFolderCounts)?.length === 0) {
      sortedFolderCounts[countObj.folderId] = { 
        folderId: countObj.folderId,
        data: [countObj], 
        total: countObj.resultCount
      };
    } else {
      if (Object.keys(sortedFolderCounts).includes(countObj.folderId.toString())) {
        sortedFolderCounts[countObj.folderId] = {
          ...sortedFolderCounts[countObj.folderId],
          data: [...sortedFolderCounts[countObj.folderId].data, countObj],
          total: sortedFolderCounts[countObj.folderId].total + countObj.resultCount
        }
      } else {
        sortedFolderCounts[countObj.folderId] = {
          folderId: countObj.folderId,
          data: [countObj],
          total: countObj.resultCount
        }
      }
    }
  })
  
  Object.keys(sortedFolderCounts).map(folderId => {
    const sortedStatesCounts = {};
    const folderData = sortedFolderCounts[folderId];
    folderData.data.map(data => {
      if (Object.keys(sortedStatesCounts)?.length === 0) {
        sortedStatesCounts[data.stateId] = { 
          stateId: data.stateId,
          uploads: {
            [data.uploadId]: {
              uploadId: data.uploadId, 
              total: data.resultCount 
            }
          }, 
          total: data.resultCount
        };
      } else {
        if (Object.keys(sortedStatesCounts).includes(data.stateId.toString())) {
          sortedStatesCounts[data.stateId] = {
            ...sortedStatesCounts[data.stateId],
            uploads: {
              ...sortedStatesCounts[data.stateId].uploads, 
              [data.uploadId] : {
                uploadId: data.uploadId, 
                total: data.resultCount
              }},
            total: sortedStatesCounts[data.stateId].total + data.resultCount
          }
        } else {
          sortedStatesCounts[data.stateId] = {
            stateId: data.stateId,
            uploads: {
              [data.uploadId] : {
                uploadId: data.uploadId, 
                total: data.resultCount
              }
            },
            total: data.resultCount
          }
        }
      }
    })

    sortedFolderCounts[folderId] = {
      ...sortedFolderCounts[folderId],
      states: sortedStatesCounts,
    }
    delete sortedFolderCounts[folderId].data;
  })

  return sortedFolderCounts;
}



const formatData = (arr, statesObj, headers = false) => {
  const localExpandedKeys = [];

  const processFormattedData = (arr, statesObj, headers = false, localExpandedKeys) => {
    try {
      return arr.map((node) => {
        if (headers) {
          node.children = [];
          if (node.citation && Object.keys(node.citation).length > 0) {
            let objArray = Object.keys(node.citation).map((val) => {
              return {
                citation: statesObj[val],
                children: [...node.citation[val]],
                loadable: false,
                id: statesObj[val],
              };
            });
            node.children = objArray;
          }

          if (node.files && Object.keys(node.files).length > 0) {
            let objArray = Object.keys(node.files).map((val) => {
              return {
                citation: statesObj[val],
                children: [],
                loadable: false,
                id: statesObj[val],
              };
            });
            node.children = objArray;
          }

          node.citation = node.name;
        }

        if (node.children) {
          if (!localExpandedKeys.includes(node.id)) {
            localExpandedKeys.push(node.id);
          }
          node.children = processFormattedData(node.children, statesObj, headers, localExpandedKeys);
        }

        if (!has(node, 'isLeaf')) {
          if (
            (has(node, 'loadable') && node.loadable) ||
            (has(node, 'children') && size(node.children) > 0)
          ) {
            node.isLeaf = false;
          } else {
            node.isLeaf = true;
            node.children = [];
          }
        }

        if (node.citation || node.regulation) {
          node.title = (
            <p
              dangerouslySetInnerHTML={{
                __html: node.citation ?? node.regulation,
              }}
            />
          );
        }

        node.loading = false;
        return node;
      });
    } catch (error) {
      console.log(error);
      return arr;
    }
  };

  const finalArr = processFormattedData(arr, statesObj, headers, localExpandedKeys);
  return { finalArr, localExpandedKeys };
};

export {
  removeTrailingSlash,
  replaceStrParameters,
  isLastElementInArray,
  isLogsEnabled,
  removeElementFromArrayConsideringData,
  pushToArray,
  filterStateName,
  generateYearOptions,
  returnCardImage, 
  decodeToken,
  exportHtmlToDoc,
  formatUnixToDate,
  capitalizeFirstLetter,
  normalizePriceFormat,
  processCounts,
  formatData,
  formatISOToDate
};
